import * as Sentry from "@sentry/browser";
import { BrowserTracing } from "@sentry/tracing";
import {
  CaptureConsole as CaptureConsoleIntegration,
} from "@sentry/integrations";

Sentry.init({
  dsn: process.env.MIX_SENTRY_PRD_DSN,
  environment: "production",
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1,
  replaysSessionSampleRate: 0.2,
  replaysOnErrorSampleRate: 1.0,
  denyUrls: ['lp', 'googleads'],
  integrations: [
    new CaptureConsoleIntegration({
      levels: ['error']
    }),
    new Sentry.Replay({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
});

window.Sentry = Sentry;

export default Sentry;
